import { createNgReactBridgeConstant } from '../../react-bridge'
import loadingMessages from './loading-messages.json'

createNgReactBridgeConstant('csLoadingMessages', loadingMessages)
